// extracted by mini-css-extract-plugin
export default {"SummaryRow":"Summary_SummaryRow__DQLdK","RowName":"Summary_RowName__1yf76","Clickable":"Summary_Clickable__-G50n","Disclaimer":"Summary_Disclaimer__HoL3a"};